export default {
  computed: {
    isAddressDataIncorrect() {
      return this.isAddressLivingAndRegistrationTheSame ? !this.userData.address_str : (!this.userData.address_str || !this.living_address_str);
    }
  }
}